/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const populateChallengeBodySchema = z.object({
  challengeId: z.number().optional(),
  challengeIds: z.array(z.number()).optional(),
  collectionSlug: z.string().optional(),
  batchSize: z.number().min(1).max(50).optional().default(10),
  backfill: z.boolean().optional().default(false),
  forceFill: z.boolean().optional().default(false),
  afterId: z.number().optional(),
});

export type IPopulateChallengeBody = z.infer<typeof populateChallengeBodySchema>;
